const AVATAR_GRADIENTS = [
  "var(--avatar-gradient-1)",
  "var(--avatar-gradient-2)",
  "var(--avatar-gradient-3)",
  "var(--avatar-gradient-4)",
  "var(--avatar-gradient-5)",
  "var(--avatar-gradient-6)",
];

const AVATAR_SOLIDS = [
  "var(--avatar-solid-1)",
  "var(--avatar-solid-2)",
  "var(--avatar-solid-3)",
  "var(--avatar-solid-4)",
  "var(--avatar-solid-5)",
  "var(--avatar-solid-6)",
];

export function getAvatarGradient(name: string): string {
  const index = Math.abs(name?.charCodeAt(0) || 0) % AVATAR_GRADIENTS.length;
  return AVATAR_GRADIENTS[index];
}

export function getAvatarSolid(name: string): string {
  const index = Math.abs(name?.charCodeAt(0) || 0) % AVATAR_SOLIDS.length;
  return AVATAR_SOLIDS[index];
}

export function getInitials(name?: string): string {
  if (!name) return "?";
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return "?";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

export { AVATAR_GRADIENTS, AVATAR_SOLIDS };


